module.exports = __webpack_public_path__ + "img/ring_r_s_1_0@2x.57e79005.png";